import VueConfirmDialog from './VueConfirmDialog.vue';
import { emitter } from './emitter';

/**
 * Local Vue 3 port of vue-confirm-dialog 1.0.2 (Vue-2-only, event-bus based).
 * Same API: global <vue-confirm-dialog> component + this.$confirm({...}).
 */
export default {
	install(app, args = {}) {
		app.component(args.componentName || 'vue-confirm-dialog', VueConfirmDialog);

		const confirm = (params) => {
			if (typeof params !== 'object' || Array.isArray(params)) {
				throw new Error('Options type must be an object.');
			}
			if (params.callback && typeof params.callback !== 'function') {
				throw new Error('Callback type must be a function.');
			}
			emitter.emit('open', params);
		};
		confirm.close = () => emitter.emit('close');

		app.config.globalProperties.$confirm = confirm;
	},
};
